var _circle, _circle2, _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentSuccessful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#6900FF",
    fillOpacity: 0.06
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.0009,
    cy: 50,
    r: 40.583,
    fill: "#6900FF",
    fillOpacity: 0.18
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.671,
    cy: 48.6548,
    rx: 21.0762,
    ry: 20.852,
    fill: "#FFFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2234 20.3477C33.7495 20.3477 20.3467 33.7505 20.3467 50.2243C20.3467 66.6982 33.7495 80.101 50.2234 80.101C66.6972 80.101 80.1 66.6982 80.1 50.2243C80.1 33.7505 66.6972 20.3477 50.2234 20.3477ZM65.7722 40.2113L46.4672 63.1934C46.2555 63.4456 45.992 63.6494 45.6946 63.7909C45.3972 63.9324 45.0729 64.0083 44.7436 64.0136H44.7048C44.3827 64.0135 44.0642 63.9456 43.7699 63.8145C43.4757 63.6833 43.2124 63.4918 42.9969 63.2523L34.7234 54.0595C34.5133 53.8366 34.3498 53.574 34.2427 53.2871C34.1355 53.0001 34.0867 52.6947 34.0993 52.3886C34.1119 52.0826 34.1855 51.7822 34.3158 51.505C34.4461 51.2278 34.6306 50.9795 34.8582 50.7746C35.0859 50.5697 35.3522 50.4124 35.6416 50.3119C35.9309 50.2114 36.2374 50.1698 36.5431 50.1894C36.8488 50.2091 37.1474 50.2896 37.4215 50.4264C37.6956 50.5631 37.9396 50.7532 38.1391 50.9856L44.6445 58.2135L62.253 37.2553C62.648 36.7986 63.2068 36.5157 63.8087 36.4678C64.4106 36.4198 65.0071 36.6106 65.4694 36.999C65.9317 37.3873 66.2227 37.942 66.2793 38.5431C66.336 39.1442 66.1538 39.7435 65.7722 40.2113Z",
    fill: "#6900FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7603 24.6013C40.7628 24.8506 40.7752 26.2711 39.7772 26.5379L37.709 27.0907C37.3574 27.1846 37.0846 27.4622 36.9968 27.8154L36.4801 29.8929C36.2308 30.8954 34.8104 30.9078 34.5436 29.9098L33.9908 27.8416C33.8969 27.49 33.6193 27.2172 33.2661 27.1294L31.1886 26.6128C30.1861 26.3635 30.1737 24.943 31.1717 24.6762L33.2399 24.1234C33.5915 24.0295 33.8643 23.7519 33.9521 23.3987L34.4687 21.3212C34.718 20.3187 36.1385 20.3063 36.4053 21.3043L36.958 23.3725C37.052 23.7241 37.3296 23.9969 37.6828 24.0847L39.7603 24.6013Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccessful);
export default __webpack_public_path__ + "static/media/payment-successful.2d610cf09177a33e2afe1794a28a480d.svg";
export { ForwardRef as ReactComponent };